module.exports = __webpack_public_path__ + "img/icons B_39.40193862.png";